import env from '@/env';
import { Route } from '@/types';

const routes: Route[] = [
  {
    path: '/admin',
    roles: [env.roles.apiPublisher],
    organisation: true,
  },
  {
    path: '/dashboard',
    roles: [env.roles.apiPublisher],
    routes: [
      {
        path: '/my-data/:id',
        roles: [env.roles.bankAdmin],
      },
    ],
    organisation: true,
  },
  {
    path: '/auth',
    routes: [
      {
        path: '/auth/organisation',
        roles: [env.roles.apiPublisher],
      },
      {
        path: '/auth/bank-detail',
        roles: [env.roles.apiPublisher],
      },
    ],
  },
];

export default routes;
